<template>
  <div class="invoices-list tab-table">
    <InvoicesTable :exclude-columns="['customer_uuid']" :hide-actions="hideActions"
                   :hide-action-buttons="hideActionButtons" v-if="initialized"
                   :exclude-search-fields="['customer_uuid', 'shipping_status', 'first_name', 'last_name', 'company_name']"
                   :accounting-system-params="{customer_uuid: customer.uuid}" enableFrontendExport
    />
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import InvoicesTable from "../../../invoices/InvoicesTable";
  import {
    ACTION_BATCH_INVOICE_GENERATE,
    ACTION_CREATE_NEW_INVOICE,
    ACTION_MARK_INVOICE_DISPATCHED,
    ACTION_BATCH_SHIPPING_CHARGES,
    ACTION_UNMARK_INVOICE_DISPATCHED,
  } from "@/modules/constants";
  import CustomerService from "@/modules/customer/CustomerService";
  import cloneDeep from "lodash/cloneDeep";

  const {mapState} = createNamespacedHelpers('customer/customerView');
  const {mapActions: invoicesMapActions} = createNamespacedHelpers('invoices');

  export default {
    name: "InvoicesList",
    components: {InvoicesTable},
    data() {
      return {
        hideActions: [
          ACTION_CREATE_NEW_INVOICE,
          ACTION_BATCH_INVOICE_GENERATE,
          ACTION_MARK_INVOICE_DISPATCHED,
          ACTION_UNMARK_INVOICE_DISPATCHED,
          ACTION_BATCH_SHIPPING_CHARGES,
        ],
        hideActionButtons: [],
        initialized: false
      }
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
      })
    },
    methods: {
      ...invoicesMapActions(['updateTableSource'])
    },
    async beforeMount() {
      let tmpCustomer = cloneDeep(this.customer)
      let response = await CustomerService.getCustomer(this.customer.uuid, 'shipping_address.country,billing_address.country,term')
      if (response.success) {
        tmpCustomer = response.body
      }

      this.initialized = true
      await this.updateTableSource({
        source: 'customer',
        customer: tmpCustomer,
        extraFilters: {customer_uuid: this.customer.uuid},
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
